import { getLang } from '../helpers'
import { useBookingFormStore } from '../providers/BookingFormStoreProvider'
import { IDestination } from '../store/data'
import {
  DESTINATION_PARAM,
  HOTEL_PARAM,
  ROOM_TYPE_PARAM,
  useQueryParams,
  VISIT_END_PARAM,
  VISIT_START_PARAM,
  VISIT_TYPE_PARAM,
} from './useQueryParams'
import { useVisitTypeCategoriesAccordion } from './useVisitTypeCategoriesAccordion'

export const useDestinationsAccordion = () => {
  const language = useBookingFormStore((state) => state.language)
  const destinations = useBookingFormStore((state) => state.destinations)
  const hotel = useBookingFormStore((state) => state.hotel)
  const changeVisitType = useBookingFormStore((state) => state.changeVisitType)
  const changeDestination = useBookingFormStore((state) => state.changeDestination)
  const changeHotel = useBookingFormStore((state) => state.changeHotel)
  const changeRoomType = useBookingFormStore((state) => state.changeRoomType)

  const { addQueryParameter, removeQueryParametersArray } = useQueryParams()
  const { removeRoomHotel } = useVisitTypeCategoriesAccordion()

  const removeRelatedDestinationQueryParams = async () => {
    changeVisitType(null)
    changeHotel(null)
    changeRoomType(null)
    await removeQueryParametersArray([
      DESTINATION_PARAM,
      VISIT_TYPE_PARAM,
      HOTEL_PARAM,
      ROOM_TYPE_PARAM,
      VISIT_START_PARAM,
      VISIT_END_PARAM,
    ])
  }

  const updateRouteQuery = async (destination: IDestination | null) => {
    if (destination) {
      await addQueryParameter(DESTINATION_PARAM, getLang(destination.name, language))
    } else {
      await removeRelatedDestinationQueryParams()
    }
  }

  const validateDestinationRelations = async (destination: IDestination) => {
    const allDestinations = destinations ?? []
    if (
      allDestinations.some(
        (destinationItem) => Number(destinationItem.id) === Number(destination.id)
      )
    ) {
      if (hotel && Number(hotel.destination.id) !== Number(destination.id)) {
        await removeRoomHotel()
      }
    } else {
      await removeRelatedDestinationQueryParams()
    }
  }

  const onChangeDestination = async (value: IDestination | null) => {
    if (value) {
      await validateDestinationRelations(value)
    }
    changeDestination(value)
    await updateRouteQuery(value)
  }

  const onInitDestinationValidation = async (destination: IDestination | null) => {
    if (destination) {
      await validateDestinationRelations(destination)
    } else {
      await removeRelatedDestinationQueryParams()
    }
  }

  return {
    onChangeDestination,
    onInitDestinationValidation,
  }
}
